export default "__VITE_ASSET__HUXOL5Qy__"